export const ExchangeMatchType = {
    back: "Back",
    lay: "Lay",
    yes: "Yes",
    no: "No",
  };